import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const getPartners = async () => {
  const res = await axios.get(
    `${BASE_URL}CompanyAPI/GetPartnerWithUs`
  );

  let partnersData = [];

  if (res?.data?.data && Array.isArray(res.data.data)) {
    partnersData = res.data.data;
  } else if (res?.data?.result && Array.isArray(res.data.result)) {
    partnersData = res.data.result;
  } else if (Array.isArray(res.data)) {
    partnersData = res.data;
  } else if (res?.data && typeof res.data === "object") {
    partnersData = Object.values(res.data).filter(
      (item) => item && typeof item === "object"
    );
  }

  return partnersData;
};